import React from 'react';

import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box, Stack, Typography } from '@mui/material';

import { getMissingCardSx } from '../surcharges/surchargeCardStyles';

import type { MissingBlackoutRoomType } from './appliedBlackoutUtils';

interface Props {
  missingRoomTypes: Array<MissingBlackoutRoomType>;
}

export default function MissingBlackoutRoomTypeCards({ missingRoomTypes }: Props) {
  if (missingRoomTypes.length === 0) {
    return null;
  }

  return (
    <>
      {missingRoomTypes.map((roomType) => (
        <Box key={roomType.roomTypeId} sx={getMissingCardSx}>
          <Stack
            alignItems={{ xs: 'flex-start', md: 'center' }}
            direction={{ xs: 'column', md: 'row' }}
            flexWrap="wrap"
            gap={1.5}
            rowGap={1}
          >
            <Stack alignItems="center" direction="row" spacing={0.75} sx={{ color: 'warning.dark', flexShrink: 0 }}>
              <WarningAmberOutlinedIcon fontSize="small" />
              <Typography fontWeight={700} variant="body2">
                Missing
              </Typography>
            </Stack>
            <Typography fontWeight={700} variant="body2">
              {roomType.roomTypeName}
            </Typography>
            <Typography color="text.secondary" sx={{ minWidth: 0 }} variant="body2">
              No matching room-rate blackout block yet.
            </Typography>
          </Stack>
        </Box>
      ))}
    </>
  );
}
